import { fabric } from "fabric"

export default function createDynamicFabricClass(base: any, type: string) {
	return fabric.util.createClass(base, {
		type,

		initialize: function (...rest: any[]) {
			const options = rest[rest.length - 1]
			const dynamicOptions = {} as any

			for (let k in options) {
				const v = options[k]
				if (typeof v === 'function') {
					dynamicOptions[k] = v
					options[k] = v()
				}
			}


			this.callSuper('initialize', ...rest);


			this.set('_dynamicOptions', dynamicOptions)
		},

		_render: async function (ctx: any) {
			for (let k in this._dynamicOptions) {
				const v = this._dynamicOptions[k]
				this.set(k, v())
			}

			await this.callSuper('_render', ctx);
		}
	})
}